module.exports = __webpack_public_path__ + "img/exam.15f4d92b.png";